export enum EDocumentType {
  FILE = 'file',
  RESOURCE = 'resource',
  GLOBAL = 'global',
  SHARED = 'shared',
}

export interface DocumentInterface {
  lastModified: Date|string;
  name: string;
  bytes: number;
}

export class Document implements DocumentInterface {
  static readonly KB = 1_024;
  static readonly MB = 1_024 * Document.KB;
  static readonly GB = 1_024 * Document.MB;

  lastModified: Date;
  name: string;
  bytes: number;

  constructor({ lastModified, name, bytes }: DocumentInterface) {
    this.lastModified = new Date(lastModified);
    this.name = name;
    this.bytes = bytes;
  }

  public static fromList(documents: DocumentInterface[]): Document[] {
    return documents.map(document => new Document(document));
  }

  match(document: Document): boolean {
    return this.name === document.name && this.bytes === document.bytes;
  }

  getNameBase64(type: EDocumentType, memberId?: number): string {
    const info = [this.name, type];
    if (memberId) {
      info.push(memberId.toString());
    }
    return btoa(info.join(':'));
  }
}
